export interface CertificateMetadata {
  backgroundColor?: string;
  estimatedTrainingHours?: number;
  signatories?: { name: string; title: string }[];
  surveyUrl?: string;
  [key: string]: unknown;
}

export interface CertificateImage {
  url: string;
  alt?: string | null;
}

// The parts of a published award the certificate PDF draws.
export interface CertificateAward {
  image?: CertificateImage | null;
  certificateConfig?: {
    skills?: { skill: string }[] | null;
    badgeImage?: CertificateImage | null;
    logoImage?: CertificateImage | null;
    descriptionText?: string | null;
    // A JSON field: an object, or a JSON string from older content.
    metadata?: CertificateMetadata | string | null;
  } | null;
}

export const parseCertificateMetadata = (
  raw: CertificateMetadata | string | null | undefined,
): CertificateMetadata => {
  if (!raw) return {};
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw) as CertificateMetadata;
    } catch {
      return {};
    }
  }
  return raw;
};

// Award completions record a calendar date (YYYY-MM-DD). Reading it at 04:00
// UTC keeps it on the same day across US time zones.
export const formatCompletionDate = (
  completedAt: string | null | undefined,
): string =>
  completedAt
    ? new Date(completedAt + "T04:00:00Z").toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
    : "";
